import { useAuth } from '../context/AuthContext';
import { TFunction } from 'i18next';

export type UserStatus = 'new' | 'wait-for-acceptance' | 'approved' | 'rejected' | 'inactive';

interface UserPermissions {
  canAccessProducts: boolean;
  canEditProfile: boolean;
  canPlaceOrders: boolean;
  showApprovalRequest: boolean;
  showWaitingMessage: boolean;
  canLogin: boolean;
}

export const useUserPermissions = (): UserPermissions => {
  const { user } = useAuth();
  const status = user?.status as UserStatus || 'new';

  const permissions: UserPermissions = {
    canAccessProducts: status === 'approved',
    canEditProfile: status === 'new' || status === 'approved',
    canPlaceOrders: status === 'approved',
    showApprovalRequest: status === 'new',
    showWaitingMessage: status === 'wait-for-acceptance',
    canLogin: status !== 'rejected' && status !== 'inactive'
  };

  return permissions;
};

export const getUserStatusMessage = (status: UserStatus, t: TFunction): string => {
  switch (status) {
    case 'new':
      return t('userStatus.new');
    case 'wait-for-acceptance':
      return t('userStatus.waitForAcceptance');
    case 'approved':
      return t('userStatus.approved');
    case 'rejected':
      return t('userStatus.rejected');
    case 'inactive':
      return t('userStatus.inactive');
    default:
      return '';
  }
};